import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useRevisionVisualize } from '@/features/exam-revision/hooks/useRevisionVisualize';
import { RevisionVisualizeTemplate } from '@/features/exam-revision/ui/templates/RevisionVisualizeTemplate';

export const Route = createFileRoute('/_authenticated/exam/revision/$examId/visualize/')({
  component: RevisionVisualizePage,
});

export function RevisionVisualizePage() {
  const { examId } = Route.useParams();
  const [page, setPage] = useState(1);

  const { exam, question, currentPage, totalPages, isLoading, isError, refetch } =
    useRevisionVisualize(Number(examId), page);

  return (
    <RevisionVisualizeTemplate
      exam={exam}
      question={question}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setPage}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
    />
  );
}
